import React from "react";
import { MDBRow, MDBCard, MDBCardBody } from "mdbreact";
import TeamMember from "../../../components/TeamMember/TeamMember";

const Team = (props) => {
  const { staff } = props;
  console.log(staff);
  return (
    <MDBCard className="my-5 px-5 pb-5 text-center">
      <MDBCardBody>
        <h2 className="h1-responsive grey-text font-weight-bold my-5">
          {staff.title}
        </h2>
        <p className="grey-text w-responsive mx-auto mb-5">
          {staff.description}
        </p>
        <MDBRow>
          {staff.list.map((prop, key) => (
            <TeamMember key={key} {...prop} />
          ))}
        </MDBRow>
      </MDBCardBody>
    </MDBCard>
  );
};

export default Team;



// WEBPACK FOOTER //
// ./src/views/About Us/Sections/Team.js